import base from '@/__vue2stone/service/api/v1/__base'
import preUrl from '@/service/app/processor'
export default {
  async index({ params }) {
    return base.index({
      modelName: 'license_type',
      preUrl: preUrl.getFactoryPreUrl(),
      params: params,
    })
  },
}